import { Box, IconButton, Input, Switch } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
import httpCommon from '../../../http-common';
import CustomExportButton from '../../../common/components/Table/CustomExportButton';
import { v4 } from "uuid";
import { useGridApiRef } from '@mui/x-data-grid';
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import { Delete as DeleteIcon } from '@mui/icons-material';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { FileUploaderRipik } from '../../HomePage/components/FileUploaderRipik';
import { mixpanelTrackTabsButton } from '../../../mixPanelFunctions/mixPanelFunctions';

const postRecipe = async (recipe_data) => {
  const data = JSON.stringify({ ...recipe_data });
  try {
    const response = await httpCommon.post(`/v1/qc/recipe`, data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Recipe couldn't be added, response message:${result.message}`);
  } catch (error) {
    alert(error);
    return false;
  }
};

const deleteRecipe = async (recipe_body) => {
  const data = JSON.stringify({ ...recipe_body });
  try {
    const response = await httpCommon.delete(`/v1/qc/recipe`, { data });
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Analyst couldn't be deleted, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return false;
  }
};

const RecipeCell = ({ value, id, handle_change, type = "text" }) => {
  return <Input
    value={value}
    id={id}
    onChange={(e) => {
      handle_change(e);
    }}
    onKeyDown={(e) => {
      e.stopPropagation();
    }}
    type={type} />;
};

const RecipeDashboard = () => {
  const apiRef = useGridApiRef();

  const [rows, set_rows] = useState([]);

  const fetch_data = async () => {
    try {
      const response = await httpCommon.get(`/v1/qc/recipe`);
      const result = response.data.data.map((item) => ({
        ...item,
        id: item._id
      }));
      return result;
    } catch (error) {
      console.log({ error });
    }
  };

  const initialize_data = async () => {
    const data = await fetch_data();
    set_rows(data);
  };

  const handleDeleteRecipe = async (params) => {
    // console.log({ params });
    const {
      "Product Name": product_name,
      "Spec ID": spec_id,
      "STP ID": stp_id,
      "Test ID": test_id,
    } = params.row;
    const response = await deleteRecipe({
      product_name, spec_id, stp_id, test_id
    });
    if (response === true) {
      const row_id = params.row.id;
      apiRef.current.updateRows([{
        id: row_id,
        // _action: "delete"
        is_disabled: !params?.row?.is_disabled
      }]);
    }
    else {
      console.log("probably this analyst doesn't exist, reloading the data for you.");
      initialize_data();
    }
  };

  const columns = [
    {
      "field": "Product Name",
      "headerName": "Product Name",
      "editable": false,
      "width": 150,
    },
    {
      "field": "Spec ID",
      "headerName": "Spec ID",
      "editable": false,
      "width": 150,
    },
    {
      "field": "STP ID",
      "headerName": "STP ID",
      "editable": false,
      "width": 150,
    },
    {
      "field": "Test ID",
      "headerName": "Test ID",
      "editable": false,
      "width": 200,
    },
    {
      "field": "Pre-analyst fixed time",
      "headerName": "Pre-analyst fixed time",
      "editable": true,
      "width": 150,
    },
    {
      "field": "Pre-analyst additional time",
      "headerName": "Pre-analyst additional time",
      "editable": true,
      "width": 150,
    },
    {
      "field": "Machine fixed time",
      "headerName": "Machine fixed time",
      "editable": true,
      "width": 150,
    },
    {
      "field": "Machine additional time",
      "headerName": "Machine additional time",
      "editable": true,
      "width": 150,
    },
    // {
    //   "field": "Post-analyst/review fixed time",
    //   "headerName": "Post-analyst/review fixed time",
    //   "editable": true,
    //   "width": 150,
    // },
    // {
    //   "field": "Post-analyst/review additional time",
    //   "headerName": "Post-analyst/review additional time",
    //   "editable": true,
    //   "width": 150,
    // },
    {
      "field": "Analyst Group",
      "headerName": "Analyst Group",
      "editable": true,
      "width": 150,
    },
    {
      "field": "Clubbing Group",
      "headerName": "Clubbing Group",
      "editable": true,
      "width": 150,
    },
    {
      "field": "Market STP",
      "headerName": "Market STP",
      "editable": true,
      "width": 150,
    },
    {
      field: 'is_disabled',
      headerName: 'Enable',
      width: 100,
      renderCell: (params) => {
        // console.log({ params });
        return (
          <div style={{ position: 'sticky', right: 0, zIndex: 1 }}>
            <Switch checked={!params?.row?.is_disabled} onClick={() => {
              handleDeleteRecipe(params);
            }} />
            {/* <IconButton onClick={() => handleDeleteRecipe(params)}>
              <DeleteIcon style={{ color: '#ff5722' }} />
            </IconButton> */}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    initialize_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveOnServer = async (updatedRow) => {
    const {
      _id,
      "Product Name": product_name,
      "Spec ID": spec_id,
      "STP ID": stp_id,
      "Test ID": test_id,
      ...update_fields
    } = updatedRow;

    delete update_fields.id;

    const data = JSON.stringify({
      product_name,
      spec_id,
      stp_id,
      test_id,
      update_fields: Object.keys(update_fields).reduce((acc, el) => ({
        ...acc,
        [el]: +update_fields[el] || update_fields[el]
      }), {})
    });
    const response = await httpCommon.patch(`/v1/qc/recipe`, data);
    const result = response.data.status;
    if (result === "success") return true;
    else return false;
  };

  const initial_new_dg_row = () => {
    return [{
      "id": v4(),
      "Product Name": "",
      "Spec ID": "",
      "STP ID": "",
      "Test ID": "",
      "Pre-analyst fixed time": "",
      "Pre-analyst additional time": "",
      "Machine fixed time": "",
      "Machine additional time": "",
      "Analyst Group": "",
      "Clubbing Group": "",
      "Market STP": "",
    }];
  };

  const [new_dg_row, set_new_dg_row] = useState(initial_new_dg_row());

  const handle_change_new_row_data = (e) => {
    const { id, value } = e.target;
    const old = { ...new_dg_row[0] };
    old[id] = value;
    set_new_dg_row([{ ...old }]);
  };

  const new_dg_columns = [
    {
      "field": "Product Name",
      "headerName": "Product Name",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Product Name']} handle_change={handle_change_new_row_data} id={"Product Name"} />;
      },
    },
    {
      "field": "Spec ID",
      "headerName": "Spec ID",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Spec ID']} handle_change={handle_change_new_row_data} id={"Spec ID"} />;
      },
    },
    {
      "field": "STP ID",
      "headerName": "STP ID",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['STP ID']} handle_change={handle_change_new_row_data} id={"STP ID"} />;
      },
    },
    {
      "field": "Test ID",
      "headerName": "Test ID",
      "editable": false,
      "width": 200,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Test ID']} handle_change={handle_change_new_row_data} id={"Test ID"} />;
      },
    },
    {
      "field": "Pre-analyst fixed time",
      "headerName": "Pre-analyst fixed time",
      "editable": false,
      "type": "number",
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Pre-analyst fixed time']} handle_change={handle_change_new_row_data} id={"Pre-analyst fixed time"} type="number" />;
      },
    },
    {
      "field": "Pre-analyst additional time",
      "headerName": "Pre-analyst additional time",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Pre-analyst additional time']} handle_change={handle_change_new_row_data} id={"Pre-analyst additional time"} type="number" />;
      },
    },
    {
      "field": "Machine fixed time",
      "headerName": "Machine fixed time",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Machine fixed time']} handle_change={handle_change_new_row_data} id={"Machine fixed time"} type="number" />;
      },
    },
    {
      "field": "Machine additional time",
      "headerName": "Machine additional time",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Machine additional time']} handle_change={handle_change_new_row_data} id={"Machine additional time"} type="number" />;
      },
    },
    // {
    //   "field": "Post-analyst/review fixed time",
    //   "headerName": "Post-analyst/review fixed time",
    //   "editable": false,
    //   "width": 150,
    // },
    // {
    //   "field": "Post-analyst/review additional time",
    //   "headerName": "Post-analyst/review additional time",
    //   "editable": false,
    //   "width": 150,
    // },
    {
      "field": "Analyst Group",
      "headerName": "Analyst Group",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Analyst Group']} handle_change={handle_change_new_row_data} id={"Analyst Group"} type="number" />;
      },
    },
    {
      "field": "Clubbing Group",
      "headerName": "Clubbing Group",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Clubbing Group']} handle_change={handle_change_new_row_data} id={"Clubbing Group"} type="number" />;
      },
    },
    {
      "field": "Market STP",
      "headerName": "Market STP",
      "editable": false,
      "width": 150,
      "cellClassName": "border hover:bg-white",
      renderCell: () => {
        return <RecipeCell value={new_dg_row[0]['Market STP']} handle_change={handle_change_new_row_data} id={"Market STP"} type="number" />;
      },
    },
    {
      "field": "add_row",
      "headerName": "",
      "editable": false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          const vals = Object.values(row);
          for (let val of vals) {
            if (val === "" || val === null) {
              alert("Please enter all the fields before adding the recipe.");
              return;
            }
          }
          const {
            id,
            "Product Name": product_name,
            "Spec ID": spec_id,
            "STP ID": stp_id,
            "Test ID": test_id,
            ...rest
          } = row;
          const recipe_data = { product_name, spec_id, stp_id, test_id, add_fields: rest };
          const response = await postRecipe(recipe_data);
          if (response === true) {
            apiRef.current.updateRows([{ ...row }]);
            set_new_dg_row(initial_new_dg_row());
          }
          else {
            alert("couldn't update :(");
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      }
    }
  ];

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);

  const handle_file_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      // console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_mastersheet/recipe/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      mixpanelTrackTabsButton("RecipeDashboard","file upload","master-sheet") // tracking tab button
      console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully!`,
          open: true,
          severity: "success"
        });
        initialize_data();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Box>
      <Box className="mb-4">
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex justify-end items-center">
          <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
            set_file(uploaded_file);
            console.log(uploaded_file);
            handle_file_upload(uploaded_file);
          }} upload_message={`Upload File Here`} />
        </Box>
        <CustomDataGrid
          apiRef={apiRef}
          columns={columns}
          rows={rows}
          sx={{
            height: "500px"
          }}
          slots={{
            toolbar: CustomExportButton
          }}
          initialState={{
            pinnedColumns: {
              right: ["is_disabled"],
            }
          }}
          hideFooterRowCount
          hideFooterSelectedRowCount
          disableRowSelectionOnClick
          processRowUpdate={async (updatedRow, originalRow) => {
            const result = await saveOnServer(updatedRow);
            if (result) return updatedRow;
            else return originalRow;
            // console.log({ updatedRow, originalRow });
            // return updatedRow;
          }}
        />
      </Box>
      <Box>
        <CustomDataGrid
          columns={new_dg_columns}
          rows={new_dg_row}
          sx={{
            height: "200px"
          }}
          initialState={{
            pinnedColumns: {
              right: ["add_row"]
            }
          }}
          hideFooter
          // hideFooterSelectedRowCount
          disableRowSelectionOnClick
        // processRowUpdate={async (updatedRow, originalRow) => {
        //   const result = await saveOnServer(updatedRow);
        //   if (result) return updatedRow;
        //   else return originalRow;
        //   // console.log({ updatedRow, originalRow });
        //   // return updatedRow;
        // }}
        />
      </Box>
    </Box>
  );
};

export default RecipeDashboard;